import styled from "styled-components";

export default styled.div`
  position: relative;

  .input-field--loading {
  }

  .input-field {
    .icon-picker {
      flex: 0;
    }

    .input {
      border-radius: 12px;
      background-color: rgba(218, 218, 218, 0.8);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      padding: 0rem 1rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-grow: 1;

      .icon-section {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .left-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.5rem;
          border-radius: 100%;

          .send-icon {
            position: relative;
            left: 2px;
          }

          &--send {
            background-color: #0ba6ff;
          }
        }
      }

      .search-area {
        flex: 1;

        .MuiInputBase-root {
          width: 100%;
          height: 100%;
          padding: 1rem 0rem;

          .MuiInputBase-input {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .input-field--loading {
    }

    .input-field {
      margin-bottom: 5px;

      .icon-picker {
      }

      .input {
        .icon-section {
          .left-icon-container {
            .send-icon {
            }

            &--send {
              background-color: transparent;

              .MuiSvgIcon-root {
                fill: #0ba6ff;
              }
            }
          }
        }

        .search-area {
          .MuiInputBase-root {
            padding: 0px 0px 0px;

            .MuiInputBase-input {
            }
          }
        }
      }
    }
  }
`;
